import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const templateEditorMarqueeStyles: IStyles = {
    marquee: {
        position: 'absolute',
        border: `1px solid ${color.blue}`,
        background: `${color.blue}22`,
        pointerEvents: 'none',
        zIndex: 30,
        boxSizing: 'border-box',
    },
}

addStyles(templateEditorMarqueeStyles)
export default templateEditorMarqueeStyles
